import { Entity } from '../../../../../game';
import { Vector } from '../../../../../types';
import { rand, randMember } from '../../../../../utils';
import { music } from '../../../../../audio';

export type PowerupType =
  | 'shipSpeed'
  | 'rapidFire'
  | 'lifeIncrease'
  | 'invincible';

const powerups: PowerupType[] = [
  'shipSpeed',
  'rapidFire',
  'lifeIncrease',
  'invincible',
];

const getRandTime = () => rand(2, 10);

export class PowerupEntity extends Entity {
  position: Vector = [-75, 200, 0];
  startPosition: Vector = [...this.position];
  visible = false;
  currentElapsedDuration = 0;
  time = 0;
  revertPowerup?: () => any;
  currentRoll?: {
    type: PowerupType;
    increase: number;
    duration: number;
  };
  secondsToAppear = getRandTime();
  step = (delta: number) => {
    this.time += delta;

    if (
      !this.visible &&
      !this.currentRoll &&
      this.time >= this.secondsToAppear
    ) {
      this.visible = true;
      this.position[0] = rand(-75, 100);
      this.currentElapsedDuration = 0;
      music.powerUpAppear();
    }

    this.currentElapsedDuration += delta;

    if (this.visible) {
      this.position[1] -= 2;

      if (this.position[1] <= -100) {
        this.reset();
      }
    }
  };

  roll() {
    const type = randMember(powerups);
    const increase = type === 'rapidFire' ? 0.6 : rand(0.5, 1.5);
    const duration = rand(10, 20);
    this.currentRoll = { type, increase, duration };
  }

  reset() {
    this.time = 0;
    this.visible = false;
    this.secondsToAppear = getRandTime();
    this.currentElapsedDuration = 0;
    this.position = this.startPosition;
    if (this.revertPowerup) {
      this.revertPowerup();
    }
    this.currentRoll = undefined;
  }
}
